export const luckyDrawBanner = '/assets/promotions/luckydraw.png' //current prize
export const luckyDrawNextBanner = '/assets/promotions/nextMonth.png' //next month prize
export const tngBanner = '/assets/promotions/tng.png'
export const incentiveBanner = '/assets/promotions/battery-incentive.png'

export const endUserScratchCardBanner =
  '/assets/promotions/end-user/scratch-card-redemption/banner.jpg'
export const endUserAppleLuckyDrawBanner =
  '/assets/promotions/end-user/apple-products-lucky-draw/banner.png'

export const dealerLuckyDrawBanner = '/assets/promotions/dealer/lucky-draw/banner.jpg'
export const dealerMysteryShopperBanner = '/assets/promotions/dealer/mystery-shopper/banner.jpg'
